<template>
  <v-row>
    <v-col cols="6">
      <Column />
    </v-col>
    <v-col cols="6">
      <Column />
    </v-col>
  </v-row>
</template>

<script>

export default {
  components: {
    Column: () => import('../components/Column.vue'),
  },
}

</script>
